import { render, staticRenderFns } from "./usingWebsite.vue?vue&type=template&id=04f282d5&"
import script from "./usingWebsite.vue?vue&type=script&lang=js&"
export * from "./usingWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports